module.exports = __webpack_public_path__ + "assets/img/7a16b7f74c67496ab61f5d4c6c63195b.svg";